module.exports = __webpack_public_path__ + "img/首页2-3.3d1a72ad.svg";